import { j as n } from "../../jsx-runtime-B6kdoens.js";
import { a as t } from "../../index-CROKJrb5.js";
import { c, f as a } from "../../create-component-CBAeEoQ6.js";
import { Typography as i } from "../Typography/index.js";
const d = c(
  "Link",
  a(({ className: r, ...o }, e) => /* @__PURE__ */ n.jsx(
    i,
    {
      as: "a",
      ref: e,
      className: t(
        "cur-cursor-pointer cur-underline cur-decoration-surface-brand-accent cur-decoration-solid cur-decoration-[.125em] cur-underline-offset-[.25em] hover:cur-decoration-[.25em] hover:cur-underline-offset-[.125em] hover:[text-decoration-skip-ink:none]",
        r
      ),
      ...o
    }
  ))
);
export {
  d as Link
};
//# sourceMappingURL=index.js.map
